module.exports = __webpack_public_path__ + "img/roller-coaster.cd1f9e68.png";